export default __webpack_public_path__ + "static/media/1298747_instagram_brand_logo_social media_icon.787b1447.svg";